export const URI_PARAMS = {
  channelSlug: 'channelSlug',
  sourceId: 'sourceId',
};
